module.exports = __webpack_public_path__ + "static/media/avatar_button_selected.c5588a5c.svg";